import {
  SUB_MODULES_LIST,
  SUB_MODULES_PAGINATION,
  SUB_MODULE_INSERT,
  SUB_MODULE_UPDATE,
  SUB_MODULE_DELETE,
} from "./constant";

const initialState = {
  loading: false,
  subModulesList: [],
  pagination: {
    totalRecord: 0,
    currentRecord: 0,
    currentPage: 1,
    nextPage: 0,
    totalPage: 1,
  },
  error: null,
};

const subModulesReducer = (state = initialState, action) => {
  switch (action.type) {
    // ================= LIST =================
    case SUB_MODULES_LIST:
      return {
        ...state,
        subModulesList: action.payload || [],
      };

    // ================= PAGINATION =================
    case SUB_MODULES_PAGINATION:
      return {
        ...state,
        pagination: action.payload || {},
      };

    // ================= INSERT =================
    case SUB_MODULE_INSERT:
      return {
        ...state,
        subModulesList: [
          action.payload,
          ...state.subModulesList,
        ],
      };

    // ================= UPDATE =================
    case SUB_MODULE_UPDATE:
      return {
        ...state,
        subModulesList: state.subModulesList.map((item) =>
          item.SUBMODULE_ID === action.payload.SUBMODULE_ID
            ? action.payload
            : item
        ),
      };

    // ================= DELETE =================
    case SUB_MODULE_DELETE:
      return {
        ...state,
        subModulesList: state.subModulesList.filter(
          (item) => item.SUBMODULE_ID !== action.payload
        ),
      };

    default:
      return state;
  }
};

export default subModulesReducer;